import Vue from 'vue'
import Vuex from 'vuex'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)


const currentSong = {
  // 讲解员信息 Object{ id name avatar }
  guide: {},
  // 播放状态 Boolean
  playing: false,
  // 当前播放专辑列表 Array
  playList: [],
  // 当前播放音频信息
  currBag: {},
  // 当前播放歌曲索引
  currIndex: -1,
  // 当前播放歌曲地址
  currUrl: ''
}

const mutations = {
  setGuide(currentSong, guide) {
    currentSong.guide = guide;
  },
  setPlaying(currentSong, playing) {
    currentSong.playing = playing;
  },
  setPlayList(currentSong, playList) {
    currentSong.playList = playList;
  },
  setCurrBag(currentSong, currBag) {
    currentSong.currBag = currBag;
  },
  setCurrIndex(currentSong, currIndex) {
    currentSong.currIndex = currIndex;
  },
  setCurrUrl(currentSong, currUrl) {
    currentSong.currUrl = currUrl;
  },
}


export default new Vuex.Store({
  currentSong,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js